import { gql } from '@apollo/client'

export const GET_FANTASY_LEAGUE_TABS_SHELL = gql`
  query GetFantasyLeagueTabsShell($fantasyLeagueId: ID!) {
    currentFantasyLeagueMember(fantasyLeagueId: $fantasyLeagueId) {
      id
      role
      activityLastReadAt
      messagesLastReadAt
      unreadEventsCount
      unreadMessagesCount
      unreadActivityCount
    }
    fantasyLeague(id: $fantasyLeagueId) {
      id
      competition {
        id
      }
    }
  }
`
